<template>
  <div class="recipe-section">
    <div class="section-title">
      <div class="section-icon"></div>
      <h2>{{ title }}</h2>
    </div>
    <slot></slot>
    <slot name="extra"></slot>
  </div>
</template>

<script>
export default {
  name: 'RecipeSection',
  props: {
    title: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped>
.recipe-section {
  margin-bottom: 24px;
}

.section-title {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}

.section-icon {
  width: 4px;
  height: 24px;
  background: var(--primary);
  border-radius: 2px;
  margin-right: 8px;
}

.section-title h2 {
  font-size: 1.3rem;
  font-weight: 600;
}
</style>